"use strict";

import Dom from "common/Dom";
import * as handlers from "./handlers";
import * as handlers2 from "components/Overlay/handlers.js";
export const bindActions = function bindActions() {
  $(Dom.intProductTile).on("click", function () {
    handlers.openProductModal($(this));
  });
  $(Dom.closeModalBtn).on("click", function () {
    handlers2.hideOverlay();
  });
  $(Dom.intPasswordForm).on("submit", function (e) {
    // e.preventDefault();
    // validateUser($(this));
  });
  $(Dom.intLink).on("click", function (e) {
    e.stopPropagation();
  });
};
